import * as React from 'react';
type Props = {
  className?: string;
};
export function Twitter({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Twitter"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.90828 20.6147H7.99297C14.9738 20.6147 20.6239 14.9646 20.6239 7.98376C20.6239 7.91117 20.6239 7.83857 20.6239 7.76598C20.6239 7.71759 20.6239 7.52401 20.6239 7.33044L20.6118 7.34253C21.4708 6.71341 22.2088 5.9512 22.8016 5.068L22.85 5.00751C22.0515 5.37047 21.1925 5.61244 20.3214 5.72133L20.2972 5.70923C21.2167 5.15269 21.9184 4.2816 22.2451 3.25322L22.2693 3.27742C21.374 3.82185 20.394 4.19691 19.3656 4.39049V4.36629C17.6476 2.5878 14.8166 2.53941 13.0381 4.2574C11.9008 5.34627 11.429 6.95538 11.7798 8.4798L11.804 8.4677C8.21074 8.28622 4.87154 6.58032 2.60911 3.78556L2.57281 3.73716C1.39925 5.76972 1.99208 8.37091 3.93995 9.68965L3.92785 9.70175C3.22614 9.67756 2.54862 9.48398 1.93159 9.14522C1.93159 11.2746 3.44391 13.1135 5.54906 13.5249C4.87154 13.7306 4.15772 13.779 3.46811 13.658H3.4802C4.07303 15.4849 5.75473 16.7189 7.66631 16.7552L7.64211 16.7673C6.0693 18.0014 4.12143 18.6668 2.12517 18.6668H2.11307C1.73801 18.6668 1.36296 18.6426 1 18.5942L1.0121 18.57C3.05676 19.9008 5.45227 20.6147 7.89618 20.6147"
        fill="#1DA1F1"
      />
    </svg>
  );
}
